import Button from "../../ui/Button/Button";

type AdminTablePaginationProps = {
  page: number;
  pageSize: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  resultsCount: number;
  onPageChange: (nextPage: number) => void;
};

const AdminTablePagination = ({
  page,
  pageSize,
  hasNextPage,
  hasPreviousPage,
  resultsCount,
  onPageChange,
}: AdminTablePaginationProps) => {
  if (!hasNextPage && !hasPreviousPage && resultsCount === 0) {
    return null;
  }

  const startResult = resultsCount === 0 ? 0 : page * pageSize + 1;
  const endResult = resultsCount === 0 ? 0 : startResult + resultsCount - 1;

  return (
    <div className="mt-4 flex items-center justify-between rounded-xl border border-myteengig-border bg-white px-4 py-3">
      <p className="text-sm text-myteengig-text-muted">Showing {startResult} - {endResult}</p>

      <div className="flex items-center gap-3">
        <Button
          variant="outline"
          disabled={!hasPreviousPage}
          onClick={() => onPageChange(page - 1)}
          className="disabled:opacity-50"
        >
          Previous
        </Button>
        <p className="text-sm text-myteengig-text-muted">Page {page + 1}</p>
        <Button
          variant="outline"
          disabled={!hasNextPage}
          onClick={() => onPageChange(page + 1)}
          className="disabled:opacity-50"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default AdminTablePagination;
